import { api } from '../../api/client';
import type { SeriesFormat } from '../../domain/series';

export type Lineups = { radiant: string[]; dire: string[] };
export type SeriesStatus = {
  team_a_name?: string;
  team_b_name?: string;
  id: string;
  revision: number;
  bot_id: string;
  game_name: string;
  format: SeriesFormat;
  phase: string;
  held: boolean;
  deadline?: string;
  game_number: number;
  attempt: number;
  radiant_wins: number;
  dire_wins: number;
  lobby_id?: string;
  match_id?: string;
  teams: Lineups;
  ready_teams: string[];
  blockers: { code: string; team?: string; steam_id?: string }[];
  allowed_actions: string[];
  failure_reason?: string;
  durable: boolean;
  games: {
    number: number;
    attempt: number;
    winner?: string;
    resolution: string;
    match_id?: string;
  }[];
  actions: {
    id: string;
    type: string;
    actor: string;
    reason: string;
    at: string;
  }[];
};
export type SeriesAction = {
  id: string;
  expected_revision: number;
  type: string;
  reason: string;
  winner?: string;
  team?: string;
  outgoing?: string;
  incoming?: string;
  scope?: string;
  seconds?: number;
};
export const seriesAPI = {
  list: () =>
    api.get<{ series: SeriesStatus[]; total: number }>('/api/v1/series', {
      query: { limit: 500 },
    }),
  action: (id: string, action: SeriesAction) =>
    api.post<SeriesStatus>(
      `/api/v1/series/${encodeURIComponent(id)}/actions`,
      action,
    ),
};
export const seriesActionLabels: Record<string, string> = {
  retry_cleanup: 'Retry lobby cleanup',
  retry_lobby: 'Retry current lobby',
  resume_game: 'Resume match observation',
  approve_ready: 'Approve readiness',
  forfeit_series: 'Record series forfeit',
  hold: 'Hold automation',
  resume: 'Resume automation',
  cancel: 'Cancel series',
  extend_deadline: 'Extend deadline',
  replace_player: 'Replace player',
  confirm_result: 'Confirm result',
  forfeit_game: 'Record game forfeit',
  remake: 'Remake game',
};
